import type { ChakraProps, SpinnerProps } from '@chakra-ui/react'
import { Box, Spinner } from '@chakra-ui/react'
import { useTranslationsContext } from 'BrokerTsLib/src/context/TranslationsContext'

export const Loading = ({
  large = false,
  text,
  sx,
  spinnerProps,
  ...rest
}: {
  large?: boolean,
  text?: string,
  spinnerProps?: SpinnerProps
} & ChakraProps) => {

  const { translate } = useTranslationsContext()
  if (!text)
    text = translate('loading', 'Načítání') + '...'

  return (
    <Box
      sx={{
        display: 'grid',
        gap: 2,
        py: large ? 8 : 0,
        placeContent: 'center',
        placeItems: 'center',
        ...sx
      }}

      {...rest}
    >
      <Spinner {...spinnerProps} />
      {text}
    </Box>
  )
}
